import { Adb, AddShoppingCart, AppRegistration, BusinessCenter, ContactSupport, HelpCenter, ListAltSharp, Login, ShoppingBasket, ShoppingCart, ShoppingCartCheckout, Tag } from "@mui/icons-material";
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Badge, Box, Button, Divider, Drawer, Link, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Typography } from "@mui/material";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import Products from "./Products";
import Cart from "./Cart";
import { useNavigate } from "react-router-dom";

export default function PublicLayout() {
    const [open, setOpen] = React.useState(false);
    const navigate = useNavigate();

    const toggleDrawer = (newOpen: boolean) => () => {
        setOpen(newOpen);
    };

    function onOrderNow() {
        navigate("/get-started")
    }

    return (
        <Box>
            <AppBar color="error" position="fixed" sx={{ display: "flex", flexDirection: "row" }}>
                {/* Desktop View*/}
                <Toolbar variant="regular" disableGutters sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, marginLeft: 2 }} >
                    <img src="navbar-logo.png" style={{ marginRight: 10 }}></img>
                    <Button variant="text" style={{ padding: 0, margin: 0, color: 'white' }} onClick={() => navigate("/home")}>
                        PIPOY GAS
                    </Button>
                </Toolbar>
                <Toolbar sx={{ display: { xs: "none", md: "flex" } }}>
                    <Link onClick={() => navigate("/home")} variant="button" sx={{ color: 'white', paddingX: 2, cursor: "pointer" }} underline="none">Home</Link>
                    <Link onClick={() => navigate("/get-started")} variant="button" sx={{ color: 'white', paddingX: 2, cursor: "pointer" }} underline="none">Order Now</Link>
                    <Link onClick={() => navigate("/become-our-partner")} variant="button" sx={{ color: 'white', paddingX: 2, cursor: "pointer" }} underline="none">Become Our Partner</Link>
                    <Link onClick={() => navigate("/contact-us")} variant="button" sx={{ color: 'white', paddingX: 2, cursor: "pointer" }} underline="none">Contact Us</Link>
                    <Link onClick={() => navigate("/sign-in")} variant="button" sx={{ color: 'white', paddingX: 2, cursor: "pointer" }} underline="none">Sign in</Link>
                    {/* <Link href="/cart" variant="button" sx={{ color: 'white', paddingX: 2 }}><Badge badgeContent={2} color="error"><ShoppingCart></ShoppingCart></Badge></Link> */}
                </Toolbar>

                {/* Mobile View*/}
                <Toolbar variant="regular" disableGutters sx={{ width: "100%", justifyContent: "space-between", paddingLeft: 2, display: { xs: 'flex', md: 'none' } }} >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <img src="navbar-logo.png" style={{ marginRight: 10 }}></img>
                        <Button variant="text" style={{ padding: 0, margin: 0, color: 'white' }} onClick={() => navigate("/home")}>
                            PIPOY GAS
                        </Button>
                    </div>

                    <Button onClick={toggleDrawer(true)} sx={{ color: 'white' }}>
                        <MenuIcon></MenuIcon>
                    </Button>
                </Toolbar>
                <Drawer open={open} onClose={toggleDrawer(false)}>
                    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
                        <List>
                            <Link onClick={() => navigate("/home")} sx={{ textDecoration: "none", cursor: "pointer" }}>
                                <ListItem key="Home" disablePadding>
                                    <ListItemButton>
                                        <ListItemIcon style={{ minWidth: 30}}>
                                            <HomeIcon sx={{ color: "#d32f2f" }}></HomeIcon>
                                        </ListItemIcon>
                                        <ListItemText primary="HOME" sx={{ color: "#d32f2f" }} />
                                    </ListItemButton>
                                </ListItem>
                            </Link>
                            <Link onClick={() => navigate("/become-our-partner")} sx={{ textDecoration: "none", cursor: "pointer" }}>
                                <ListItem key="Become Our Partner" disablePadding>
                                    <ListItemButton>
                                        <ListItemIcon style={{ minWidth: 30}}>
                                            <BusinessCenter sx={{ color: "#d32f2f" }}></BusinessCenter>
                                        </ListItemIcon>
                                        <ListItemText primary="BECOME OUR PARTNER" sx={{ color: "#d32f2f" }} />
                                    </ListItemButton>
                                </ListItem>
                            </Link>
                            <Link onClick={() => navigate("/contact-us")} sx={{ textDecoration: "none", cursor: "pointer" }}>
                                <ListItem key="Contact Us" disablePadding>
                                    <ListItemButton>
                                        <ListItemIcon style={{ minWidth: 30}}>
                                            <ContactSupport sx={{ color: "#d32f2f" }}></ContactSupport>
                                        </ListItemIcon>
                                        <ListItemText primary="CONTACT US" sx={{ color: "#d32f2f" }} />
                                    </ListItemButton>
                                </ListItem>
                            </Link>
                            <Link onClick={() => navigate("/get-started")} sx={{ textDecoration: "none", cursor: "pointer" }}>
                                <ListItem key="ORDER NOW" disablePadding>
                                    <ListItemButton>
                                        <ListItemIcon style={{ minWidth: 30}}>
                                            <AddShoppingCart sx={{ color: "#d32f2f" }}></AddShoppingCart>
                                        </ListItemIcon>
                                        <ListItemText primary="ORDER NOW" sx={{ color: "#d32f2f" }} />
                                    </ListItemButton>
                                </ListItem>
                            </Link>
                            <Link onClick={() => navigate("/sign-in")} sx={{ textDecoration: "none", cursor: "pointer" }}>
                                <ListItem key="Sign in" disablePadding>
                                    <ListItemButton>
                                        <ListItemIcon style={{ minWidth: 30}}>
                                            <Login sx={{ color: "#d32f2f" }}></Login>
                                        </ListItemIcon>
                                        <ListItemText primary="SIGN IN" sx={{ color: "#d32f2f" }}></ListItemText>
                                    </ListItemButton>
                                </ListItem>
                            </Link>
                        </List>
                    </Box>
                </Drawer>
            </AppBar>
            <Box>
                <Outlet></Outlet>
            </Box>
        </Box>
    )
}